var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 12.1321V2.53208H14V0.13208H2.00005V2.53208H3.20005V12.1321L0.800049 14.5321V16.9321H7.04005V24.1321H8.96005V16.9321H15.2V14.5321L12.8 12.1321ZM4.16005 14.5321L5.60005 13.0921V2.53208H10.4V13.0921L11.84 14.5321H4.16005Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFalse);
export default __webpack_public_path__ + "static/media/pinFalse.bca131f6500ab592febe09d1f4394b40.svg";
export { ForwardRef as ReactComponent };